export const getWltpLink = (market: string, language: string) => {
	switch (market) {
		case 'es':
			return 'https://www.audi.es/es/web/es/tools/navigation/layer/wltp.html';

		case 'gb':
			return 'https://www.audi.co.uk/uk/web/en/audi-world/wltp.html';

		case 'de':
			return 'https://www.audi.de/de/brand/de/neuwagen/layer/wltp-lp.html';

		case 'dk':
			return 'https://www.audi.dk/dk/web/da/modeller/layer/wltp-lp.html';

		case 'it':
			return 'https://www.audi.it/it/web/it/modelli/layer/wltp-lp.html';

		case 'ie':
			return 'https://www.audi.ie/ie/web/en/models/layer/wltp-lp.html';

		case 'se':
			return 'https://www.audi.se/se/web/sv/customer-area/wltp-lp.html';

		case 'ch':
			switch (language) {
				case 'fr':
					return 'https://www.audi.ch/ch/web/fr/neuwagen/wltp.html';
				case 'de':
					return 'https://www.audi.ch/ch/web/de/neuwagen/wltp.html';

				case 'it':
					return 'https://www.audi.ch/ch/web/it/neuwagen/wltp.html';

				default:
					return 'https://www.audi.ch/ch/web/fr/neuwagen/wltp.html';
			}
		case 'lu':
			switch (language) {
				case 'fr':
					return 'https://www.audi.lu/lu/web/fr/wltp.html';
				case 'de':
					return 'https://www.audi.lu/lu/web/de/wltp.html';

				default:
					return 'https://www.audi.lu/lu/web/fr/wltp.html';
			}

		default:
			return '';
	}
};
